import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Content } from 'rsuite';
import { createROPicklist } from '../../../../redux/Reservation/sagas/routines';
import {
  getIsSaving,
  getIsSaved
} from '../../../../redux/Reservation/selectors/routes/ro-picklist/create';
import { modifyAccess } from '../../../../helpers/permission';
import * as PERMISSIONS from '../../../../constants/permissions/reservation';
import PageHeader from '../../../../components/PageHeader';
import PageLayout from '../../../../components/reservations/PageLayout';
import ROPicklistForm from '../../../../components/reservations/ROPicklistForm';
import AccessControl from '../../../../components/AccessControl';
import AccessDenied from '../../../../components/AccessDenied';
import Breadcrumb from '../../../../components/Breadcrumb';
import { reservationsROPicklistListPath } from '../../../Paths';

export default () => {
  const dispatch = useDispatch();
  const isSaving = useSelector(getIsSaving);
  const isSaved = useSelector(getIsSaved);
  const handleSubmit = body => {
    dispatch(createROPicklist({ body }));
  };

  return (
    <PageLayout>
      <AccessControl
        allowOnlyFor={modifyAccess(PERMISSIONS.RO_PICKLIST)}
        fallback={<AccessDenied />}
      >
        <Breadcrumb
          items={[
            {
              path: reservationsROPicklistListPath,
              label: 'Picklists'
            },
            { label: `Create Pick List` }
          ]}
        />

        <PageHeader title="Create Pick List" />
        <Content style={{ marginTop: 0 }}>
          <ROPicklistForm
            onSubmit={handleSubmit}
            isSaving={isSaving}
            isSaved={isSaved}
          />
        </Content>
      </AccessControl>
    </PageLayout>
  );
};
